import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faLock, faLockOpen, faPlus, faBan, faFileAlt, faRedoAlt, faSyncAlt, faFilePdf, faPrint } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from 'react-router';
import Busca from './Busca';
import { actions as actionSite } from './../../../redux/actions/site';
import { useDispatch } from 'react-redux';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import './Listagem.scss';
import pedidos from '../../../services/pedidos';
import { datetime2Front } from '../../../utils/converts';
import { generatePdf } from './pdf/createPdf';
const uniq = (a) => [...new Set(a)];

const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};


const Listagem = props => {

    const history = useHistory();
    const dispatch = useDispatch();

    const [page, setPage] = useState(0);
    const [logoLeka, setLogoLeka] = useState(null);
    const [paramsSearch, setParamsSearch] = useState([]);
    const total = props.registros.total;

    // useEffect(()=>{
		// 	const run = async () => {
		// 	const urlLogo = "https://leka-template-email.s3.sa-east-1.amazonaws.com/boleto/imagens/logo_empresa_red.png";
		// 	const logoLeka = await getBase64FromUrl(urlLogo);
		// 		setLogoLeka(logoLeka);
		// 	}
		// 	run();
    // },[]);

		// const dadosUsuarioPedido = pedido => {
		// 	const {usuario} = pedido;
		// 	const telefones = usuario.telefones;
		// 	const tel = telefones[0];
		// 	const telString = tel ? `(${tel.ddd}) ${tel.numero}` : '';

		// 	const params = {
		// 		layout:{
		// 			fillColor: function (rowIndex, node, columnIndex) {
		// 				return (columnIndex === 0) ? '#ffecf0' : null;
		// 			}
		// 		},
		// 		colSpan:2,
		// 		table: {
		// 			widths: ['25%', '75%'],
		// 			heights: [10,10,10],
					
		// 			body: [
		// 				[
		// 					{ 
		// 						text: 'NOME',
		// 						bold: true,
		// 						fontSize: 12,
		// 						color: '#a03c4e',
		// 						alignment:'left',
		// 					}, 
		// 					{ 
		// 						text: usuario.nome.toUpperCase(),
		// 						// text: 'asasas',
		// 						fontSize: 12,
		// 						color: '#000000',
		// 						alignment:'left',
		// 					}
		// 				],
		// 				[
		// 					{ 
		// 						text: 'DATA PEDIDO',
		// 						bold: true,
		// 						fontSize: 12,
		// 						color: '#a03c4e',
		// 						alignment:'left',
		// 					}, 
		// 					{ 
		// 						text: datetime2Front(pedido.createAt),
		// 						fontSize: 12,
		// 					}, 
		// 				],
		// 				[
		// 					{ 
		// 						text: 'TELEFONE',
		// 						bold: true,
		// 						fontSize: 12,
		// 						color: '#a03c4e',
		// 						alignment:'left',
		// 					}, 
		// 					{ 
		// 						text: telString ,
		// 						fontSize: 12,
		// 					}, 
		// 				]
		// 			],
		// 		},
		// 	}
		// 	return params;
		// }

		// const itemsPedido = pedido => {
		// 	const {usuario} = pedido;
		// 	const telefones = usuario.telefones;
		// 	const tel = telefones[0];
		// 	const telString = tel ? `(${tel.ddd}) ${tel.numero}` : '';

		// 	const params = {
		// 		layout:{
		// 			fillColor: function (rowIndex, node, columnIndex) {
		// 				return (columnIndex === 0) ? '#ffecf0' : null;
		// 			}
		// 		},
		// 		colSpan:2,
		// 		table: {
		// 			widths: ['25%', '75%'],
		// 			heights: [10,10,10],
					
		// 			body: [
		// 				[
		// 					{ 
		// 						text: 'NOME',
		// 						bold: true,
		// 						fontSize: 12,
		// 						color: '#a03c4e',
		// 						alignment:'left',
		// 					}, 
		// 					{ 
		// 						text: usuario.nome.toUpperCase(),
		// 						// text: 'asasas',
		// 						fontSize: 12,
		// 						color: '#000000',
		// 						alignment:'left',
		// 					}
		// 				],
		// 				[
		// 					{ 
		// 						text: 'DATA PEDIDO',
		// 						bold: true,
		// 						fontSize: 12,
		// 						color: '#a03c4e',
		// 						alignment:'left',
		// 					}, 
		// 					{ 
		// 						text: datetime2Front(pedido.createAt),
		// 						fontSize: 12,
		// 					}, 
		// 				],
		// 				[
		// 					{ 
		// 						text: 'TELEFONE',
		// 						bold: true,
		// 						fontSize: 12,
		// 						color: '#a03c4e',
		// 						alignment:'left',
		// 					}, 
		// 					{ 
		// 						text: telString ,
		// 						fontSize: 12,
		// 					}, 
		// 				]
		// 			],
		// 		},
		// 	}
		// 	return params;
		// }

		// const viaPedido = pedido => {
		// 	const params = {
		// 		layout:{

		// 			hLineWidth: function (i, node) {
		// 				return 0;
		// 			},
		// 			vLineWidth: function (i, node) {
		// 				return 0;
		// 			},
		// 		},
		// 		table: {
		// 			widths: ['50%', '50%'],
					
		// 			body: [
		// 				[
		// 					{ 
		// 						image:logoLeka, width:110, alignment:'left'
		// 					}, 
		// 					{ 
		// 						text: 'Nº: ' + pedido.sequencia,
		// 						bold: true,
		// 						fontSize: 18,
		// 						color: 'red',
		// 						alignment:'right',
		// 						margin:[0,5]
		// 					}, 
		// 				],
		// 				[
		// 					// {}
		// 					dadosUsuarioPedido(pedido)
		// 				],
		// 				[
		// 					{text:'teste'},
		// 					{}
		// 				]
		// 			],
		// 		},
		// 	}
		// 	return params;
		// }

    // const printOrder = pedido => {
    //   var win = window.open("", "_blank");
			
    //   // console.log(pedido);

		// 	const docDefinition = {
		// 		pageSize: "A4",
		// 		pageOrientation: "landscape",
		// 		pageMargins: [ 10,10,10,10 ],
		// 		content: [
		// 			{
		// 				style: "tableExample",
		// 				layout: {
		// 					hLineWidth: function (i, node) {
		// 						return 0;
		// 					},
		// 					vLineWidth: function (i, node) {
		// 						return i === 0 || i === node.table.widths.length ? 0 : 1;
		// 					},

		// 					vLineColor: function (i, node) {
		// 						return "black";
		// 					},
		// 					vLineStyle: function (i, node) {
								
		// 						return { dash: { length: 5 } };
		// 					},
		// 				},
		// 				table: {
		// 					widths: ['50%', '50%'],
		// 					heights: ['100%'],
		// 					body: [
		// 						[
		// 							viaPedido(pedido), 
		// 							viaPedido(pedido), 
		// 						]
		// 					],
		// 				},
		// 			},
		// 		],
		// 	};
		// 	pdfMake.createPdf(docDefinition, null, null, pdfFonts.pdfMake.vfs).open({}, win);
    
    // }
    

    const setAcao = (acao, id) => {
        let rota = `/painel/${props.rota}/${acao}`;
        if (id) {
            rota += `/${id}`;
        }
        history.push(rota);
    };

    const openModalCancelar = (obj) => {
        let txt;

        if(props.compra)  {
            txt = `Cancelar o pedido vai debitar do estoque. Deseja continuar?`;
        } else {
            if(obj.processado){
                txt = `Cancelar um pedido já processado vai creditar no estoque. Deseja continuar?`;
            } else {
                txt = `Deseja continuar?`;
            }
        }
        const configModal = {
            msg: txt, title: "Cancelar Pedido",
            actions: [
                { label: "Sim", class: "azul", callback: cancelar, arg: obj },
            ]
        }

        dispatch(actionSite.setModal(configModal))
    }

    const cancelar = async (obj) => {
        dispatch(actionSite.setModal(null));
        dispatch(actionSite.setLoadingMsg("Cancelando pedido..."))
        const res = await props.service.cancelar(obj._id);
        dispatch(actionSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            dispatch(actionSite.setLoadingMsg(""));
            if (!res.erro) {
                props.service.getList([], 0);
            }
        }, 2000);
    }

    const getSituacao = pedido => {
        if (!pedido.cancelado && pedido.processado && pedido.entregue) return "Entregue";
        if (!pedido.cancelado && !pedido.entregue && !pedido.processado) return "Pendente";
        if (pedido.processado && !pedido.cancelado) return "Processado";
        if (pedido.cancelado) return "Cancelado";
    }

    const podeCancelar = pedido => {
        if (props.compra) {
            return !pedido.cancelado;
        }

        if (!props.compra) {
            return !pedido.cancelado;
        }

        return false;
    }

    const podeEditar = pedido => {
        return !pedido.cancelado && !pedido.processado && !pedido.entregue;
    }

    const podeImprimir = pedido => {
        return true;
    }

    const podeProcessar = pedido => {
        if (!props.compra) {
            return !pedido.cancelado && !pedido.processado && !pedido.entregue;
        }

        return false;
    }

    const renderItems = () => {
        if (props.loadingList) {
            return (
                <tr>
                    <td colSpan={props.config.columns.length + 2}>Carregando listagem...</td>
                </tr>
            );
        }
        if (props.registros.rows.length > 0) {
            return props.registros.rows.map((ele, index) => {
                return (
                    <tr key={index} id={ele._id}>
                        {renderColumnsItems(ele)}
                        <td>{getSituacao(ele)}</td>
                        <td className="acoes">
                            <button className="view" onClick={() => { setAcao('view', ele._id) }}><FontAwesomeIcon icon={faFileAlt} /></button>
                            {podeEditar(ele) &&
                                <button className="edit" onClick={() => { setAcao('form', ele._id) }}><FontAwesomeIcon icon={faEdit} /></button>
                            }
                            {podeImprimir(ele) &&
                                <button className="print" onClick={() => { generatePdf(ele) }}><FontAwesomeIcon icon={faPrint} /></button>
                            }
                            {podeProcessar(ele) && 
                            <button className="edit" onClick={() => { setAcao('process', ele._id) }}><FontAwesomeIcon icon={faSyncAlt} /></button>
                            }
                            {podeCancelar(ele) &&
                                <button className="delete" onClick={() => { openModalCancelar(ele) }}><FontAwesomeIcon icon={faBan} /></button>
                            }
                        </td>
                    </tr>
                )
            })
        } else {
            return (
                <tr>
                    <td colSpan={props.config.columns.length + 2}>Nenhum registro encontrado</td>
                </tr>
            )
        }
    };

    const renderTitles = () => {
        const thead = (
            <tr>
                {/* { props.config.sort === 'ordem' && <td>#</td> } */}
                {renderColumns()}
                <td>Situação</td>
                <td width="250">Ações</td>
            </tr>
        );
        return thead;
    }

    const renderColumns = () => {
        return props.config.columns.map((c, i) => {
            return (
                <td key={i}>{c.label}</td>
            );
        });
    }

    const converts = {
        toImg: s => {
            return <img src={s} className="imgCrud" alt="imagem" />
        },
        toSimNao: s => {
            return s ? "Sim" : "Não";
        }
    }

    const renderColumnsItems = (row) => {
        return props.config.columns.map((c, i) => {
            const cls = c.field === "ordem" ? 'order' : '';
            return (
                <React.Fragment key={i}>
                    <td className={cls} width={c.width || ""}>
                        {renderValue(row, c)}
                    </td>
                </React.Fragment>
            );
        });
    }

    const renderValue = (row, c) => {
        try {

            let value = row[c.field];

            if (c.field.includes('.') && row) {
                value = eval(`row.${c.field}`) || null;
            }

            if (c.filter) {
                const filtrado = row[c.filter.field].find(e => e[c.filter.condition.field] === c.filter.condition.value);
                if (filtrado) {
                    value = filtrado[c.field];
                }
            }

            if (c.convert) {
                if (typeof c.convert === 'string') {
                    return converts[c.convert](value);
                } else if (typeof c.convert === 'function') {
                    return c.convert(value);
                }
            }

            return value;
        } catch (e) {

        }
    }

    const buscar = params => {
        props.service.getList(params, 0);
        setParamsSearch(params);
        setPage(0);
    }

    const getList = _ => {
        props.service.getList([], 0);
        setPage(0);
    }

    const proximo = () => {
        const skip = page + props.config.pagination.limit;
        if (skip < total) {
            props.service.getList(paramsSearch, skip);
            setPage(skip)
        }
    }

    const temProximo = () => {
        const skip = page + props.config.pagination.limit;
        return skip < total;
    }
    const temAnterior = () => {
        const skip = page - props.config.pagination.limit;
        return skip >= 0;
    }

    const anterior = () => {
        const skip = page - props.config.pagination.limit;
        if (skip >= 0) {
            props.service.getList(paramsSearch, skip);
            setPage(skip)
        }
    }

    const getNumeroUltimoItem = () => {
        let n = ((page) + props.config.pagination.limit);
        if (n > total) {
            n = total;
        }
        return n;
    }

    return (
        <>
            <div className="crudView">
                <div className="searchBox">
                    <Busca config={props.config} service={{ buscar, getList }} />
                    <button onClick={() => { setAcao('form') }} className="novo"><FontAwesomeIcon icon={faPlus} /> Novo Registro</button>
                    {props.rota === 'pedidos-venda' && <button onClick={props.validarTodosExcetoAmway} className="validar">Validar todos (exceto Amway)</button>}
                </div>
                <div className="gridView">
                    <div className="pagination">
                        <span>{page + 1}-{getNumeroUltimoItem()} de {props.registros.total}</span>
                        <div className="links">
                            <span onClick={() => anterior()} className={!temAnterior() ? "disable" : ""}>anterior</span>
                            <span onClick={() => proximo()} className={!temProximo() ? "disable" : ""}>próximo</span>
                        </div>
                    </div>
                    <table cellPadding="0" cellSpacing="0">
                        <thead>
                            {renderTitles()}
                        </thead>
                        <tbody>
                            {renderItems()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default Listagem;